export const FLAG_SHOP_ONLINE_VIDEOS = "shop-online-videos";
export const FLAG_ZITADEL_CREDENTIALS_LOGIN = "zitadel-credentials-login";
export const FLAG_ZITADEL_AZURE_LOGIN = "zitadel-azure-login";
export const FLAG_ZITADEL_GOOGLE_LOGIN = "zitadel-google-login";
export const FLAG_ZITADEL_MFA = "zitadel-mfa";
export const FLAG_ZITADEL_SMART_RESOLVE_SCHOOL = "zitadel-smart-resolve-school";
